import React, { FC } from "react";

import { Avatar } from "components/core";
import { Employees_rows } from "_graphql/visal/queries/__generated__/Employees";

type Props = {
    employee: Employees_rows | null | undefined;
};

const EmployeeView: FC<Props> = ({ employee }) => {
    return (
        <div className="space-y-6 divide-y divide-gray-200">
            <div>
                <span className="text-xs  text-secondary">
                    Staff Information
                </span>
                <div className="grid grid-cols-3 gap-6 mt-2">
                    <div className="row-span-2 flex flex-col space-y-3 items-center justify-center">
                        <Avatar alt={employee?.emp_abbrv || "N A"} size="xl" />
                    </div>
                    <div>
                        <span className="block text-sm  text-secondary">
                            Last Name
                        </span>
                        <div className="mt-1 block w-full sm:text-sm text-primary">
                            {employee?.employee_last_name || "N/A"}
                        </div>
                    </div>

                    <div>
                        <span className="block text-sm  text-secondary">
                            Other Names
                        </span>
                        <div className="mt-1 block w-full sm:text-sm text-primary">
                            {employee?.employee_first_name || "N/A"}
                        </div>
                    </div>
                    <div>
                        <span className="block text-sm  text-secondary">
                            Position
                        </span>
                        <div className="mt-1 block w-full sm:text-sm text-primary">
                            {employee?.user?.broker_role?.position || "N/A"}
                        </div>
                    </div>
                </div>
            </div>
            <div className="pt-6">
                <span className="text-xs  text-secondary">
                    Contact Information
                </span>
                <div className="grid grid-cols-3 gap-6 mt-2">
                    <div>
                        <span className="block text-sm  text-secondary">
                            Email Address
                        </span>
                        <div className="mt-1 block w-full sm:text-sm text-primary">
                            {employee?.employee_email || "N/A"}
                        </div>
                    </div>

                    <div>
                        <span className="block text-sm  text-secondary">
                            Phone Number
                        </span>
                        <div className="mt-1 block w-full sm:text-sm text-primary">
                            {employee?.employee_phonenumber || "N/A"}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EmployeeView;
